import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as glFilterComparison from './comparison'
import * as glFilterSelection from './selection'
import * as glFilterStatement from './statement'

export const DOC = gql`
  ${glFilterComparison.DOC}
  ${glFilterSelection.DOC}
  ${glFilterStatement.DOC}
  fragment FragmentGeneralLedgerFilter on GeneralLedgerFilter {
    ...FragmentGeneralLedgerFilterComparison
    ...FragmentGeneralLedgerFilterSelection
    ...FragmentGeneralLedgerFilterStatement
  }
`
export const TRANSFORMER = graphql.transformers.OUT.nullable(
  graphql.transformers.OUT.custom<
    graphql.schema.FragmentGeneralLedgerFilterFragment,
    | ents.extra.rate.gl.Filter.Comparison
    | ents.extra.rate.gl.Filter.Statement
    | ents.extra.rate.gl.Filter.Selection
    | undefined
  >(filter => {
    switch (filter.__typename) {
      case 'GeneralLedgerFilterStatement':
        return glFilterStatement.TRANSFORMER.getEntityFrom(filter)
      case 'GeneralLedgerFilterComparison':
        return glFilterComparison.TRANSFORMER.getEntityFrom(filter)
      case 'GeneralLedgerFilterSelection':
        return glFilterSelection.TRANSFORMER.getEntityFrom(filter)
      default:
        throw TypeAsserter.assertIsNever(filter)
    }
  }),
)
